import React from 'react';
import LinearProgress from "@material-ui/core/LinearProgress";
import {withStyles} from '@material-ui/core/styles';

const CustomLinearProgress = withStyles(() => ({
    root: {
        height: 4,
        borderRadius: 5,
        backgroundColor: "transparent",
    },
    bar: {
        height: 4,
        borderRadius: 5,
        backgroundColor: "var(--red_3)",
    }
}))(LinearProgress);

export default function LinearPogress() {
    return (
        <CustomLinearProgress variant="indeterminate" value={50}/>
    );
}